export var MOCK_PRODUCT = {
    code: '1',
    custom_fields: [],
    description: 'Plan Individual Simple para personas menores a 50 años',
    images: [],
    thumbnail: {
        src: 'image.png',
        title: 'Plan Individual Simple'
    },
    partner_id: 'jelper',
    price: { amount: 399.0, currency: { iso_code: 'ARS', name: 'Pesos', symbol: '$' } },
    title: 'Plan Individual Simple',
    uuid: '00000000-0000-0000-0000-000000000020'
};
//# sourceMappingURL=Product.js.map